import { FC, useState } from "react";

import classes from "./Modal.module.css";
import { getLang, i18n } from "../../i18n";

interface Props {
  isShown: boolean;
  setIsShown: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  question: string;
  btnLabel: string;
  btnClick: () => Promise<void>;
}

const Modal: FC<Props> = ({
  isShown = false,
  setIsShown,
  title,
  question,
  btnLabel,
  btnClick,
}) => {
  const lang = getLang();
  const t = i18n.modal[lang];

  const [isBusy, setIsBusy] = useState(false);
  const actionClickHandler = async () => {
    setIsBusy(true);
    await btnClick();
    setIsBusy(false);
  };
  return (
    <div
      className={`${classes.area} ${isShown ? classes.visible : ""} ${
        isBusy ? classes.busy : ""
      }`}
    >
      <div className={classes.window}>
        <div className={classes.title}>{title}</div>
        <div className={classes.question}>{question}</div>
        <div className={classes.actions}>
          <button className={classes.cancel} onClick={() => setIsShown(false)}>
            {t.cancel}
          </button>
          <button className={classes.button} onClick={actionClickHandler}>
            {btnLabel || t.confirm}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
